import { Result } from 'libs/result'
import axiosClient from "./axiosClient";

export class UsersApi {
  postLogin = async (username: string, password: string,type: number): Promise<Result<any>> => {
    try {
      const url = '/login';
      const {data} = await axiosClient.post(url, {
        username,
        password,
        loginType: type,
      });
      return Result.ok(data)
    } catch (error) {
      console.log(error.response.data)
      return Result.fail(error)
    }
  }
}
